import { Button } from "@mui/material";
import Backbutton from "assets/backbutton";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { routes } from "utils/routes";
import { filtersToClearOnBackClick } from "./Filters/FiltersHelper";
import { resetPageModifiedFilter } from "./Filters/GlobalFilters.slice";
import Typography from "./Typography";

interface Props {
  label: string;
  isButtonVisible?: boolean;
  color?: string;
  onClick?: any;
}

export default function BackButton(props: Props) {
  const { label, isButtonVisible, color, onClick } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const isAbovePropertyUser = useAppSelector((state) => state.app.loggedInUserDetails.isAbovePropertyUser);
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let links = [routes.Dashboard, routes.CorporateDashboard, routes.AdminConsole, routes.Feedback];
    if (!isAbovePropertyUser) links.push(routes.UserDashboard);
    setIsVisible(!links.includes(location.pathname));
    if (isButtonVisible) setIsVisible(true);
    if (location?.state?.backButtonVisible === false) setIsVisible(false);
  }, [location.pathname]);

  const back = () => {
    navigate(-1);
    setTimeout(() => {
      const url: string = String(location?.pathname?.split("/")[1]);
      const filtersToClear = filtersToClearOnBackClick[url] || [];
      filtersToClear.map((pageName: any) => dispatch(resetPageModifiedFilter({ pageName })));
    }, 1000);
  };

  return (
    <>
      {isVisible ? (
        <Button
          sx={{ paddingLeft: "0px", gap: "8px", marginY: { xs: "0", md: "unset" } }}
          variant="text"
          onClick={onClick ?? back}
        >
          <Backbutton color={color}></Backbutton>
          <Typography color={color ?? tokens.Text.General.Secondary} children={label} variant="body1" />
        </Button>
      ) : (
        <></>
      )}
    </>
  );
}
